export default __webpack_public_path__ + "images/fede2d52fd6f49fb7ae78c89017b1bc1.png";